export default __webpack_public_path__ + "static/media/iphonex.13c3ea7d.jpg";